/**
 * 관리자 인덱스 페이지 facade.
 *
 * 한 줄로 페이지의 정렬·페이지이동·벌크삭제를 활성화한다.
 *   new AdminIndexTable().init();
 *
 * - SortableList: `[data-sortable-tbody][data-sort-url]` tbody 를 찾아 부착.
 * - PageMoveTool / BulkSelectManager: 별도 global init 가 자동 부착하므로
 *   이 facade 는 SortableList init 만 책임진다 (단, 컨트롤러 호출 시점은 보장).
 *
 * NOTE: 마크업이 없는 페이지에서는 조용히 no-op.
 */
import { SortableList } from "./SortableList";

interface AdminIndexTableOptions {
    /** 페이지 루트(미지정 시 document) — `.admin-page` 같은 스코프를 좁히고 싶을 때만 */
    pageSelector?: string;
    /** SortableJS handle (기본 .admin-sortable__handle) */
    sortableHandle?: string;
}

export class AdminIndexTable {
    readonly #opts: AdminIndexTableOptions;
    #sortable: SortableList | null = null;

    constructor(opts: AdminIndexTableOptions = {}) {
        this.#opts = opts;
    }

    init(): this {
        const root = this.#resolveRoot();
        const tbody = root.querySelector<HTMLElement>("[data-sortable-tbody]");
        if (tbody) {
            const endpoint = tbody.dataset.sortUrl ?? "";
            if (endpoint) {
                this.#sortable = new SortableList(tbody, endpoint, {
                    handle: this.#opts.sortableHandle ?? ".admin-sortable__handle",
                }).init();
            }
        }
        return this;
    }

    destroy(): void {
        this.#sortable?.destroy();
        this.#sortable = null;
    }

    #resolveRoot(): ParentNode {
        if (!this.#opts.pageSelector) return document;
        return document.querySelector(this.#opts.pageSelector) ?? document;
    }
}
